"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.logoutWarningCommand = void 0;var _command = require("./command");


var _messageHandler = require("../messageHandler");


/**
 * Logs out the current user
 * @param id - command ID
 * @param config
 * @param state
 * @param logoutSeconds - The actual number of seconds before automatic logout based on last user activity
 */
const logoutWarningCommand = (id, config, state, logoutSeconds) => {

  //This is a clientside-only command and does not require a round trip to the SSO portal via postMessage.
  (0, _messageHandler.handleMessage)({
    data: {
      response: _command.Command.CommandResponses.logoutWarning,
      responseDetails: {
        id,
        success: true,
        logoutSeconds
      }
    }
  }, config, state);
};exports.logoutWarningCommand = logoutWarningCommand;